import moment from "moment";

import { OnSchedHelpers } from ".";

export const IsEmpty = val => {
  return (val === undefined || val == null || val.length <= 0) ? true : false;
}

export const IsNotEmpty = val => {
  return (val === undefined || val == null || val.length <= 0) ? false : true;
}

export const GetFunctionName = fun => {
  var ret = fun.toString();
  ret = ret.substr('function '.length);
  ret = ret.substr(0, ret.indexOf('('));
  return ret;
}

export const GetUrlParameter = name => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export const CreateAvailabilityUrl = (baseUrl, params, date, timezoneName) => {
  var startDate = date == null ? new Date(moment(params.date).subtract(1, 'days')) : new Date(moment(date).subtract(1, 'days'));
  var endDate = date == null ? new Date(moment(params.date).add(1, 'days')) : new Date(moment(date).add(1, 'days'));
  
  // if (params.fullAvailabilityDays && params.fullAvailabilityDays > 0) {
  //   if ((moment(endDate).add(params.fullAvailabilityDays, 'days').diff(moment(endDate).endOf('month'), 'days')) > 0) {
  //     endDate = new Date(moment(endDate).endOf('month').add(1, 'days'));
  //   }
  //   else {
  //     endDate = new Date(moment(endDate).add(params.fullAvailabilityDays, 'days'));
  //   }
  // }

  var url = baseUrl;
  url += "/" + "availability";
  url += "/" + params.serviceId;
  url += "/" + OnSchedHelpers.CreateDateString(startDate);
  url += "/" + OnSchedHelpers.CreateDateString(endDate);

  url = OnSchedHelpers.IsEmpty(params.locationId) ? url : AddUrlParam(url, "locationId", params.locationId);
//        url = OnSchedHelpers.IsEmpty(params.tzOffset) ? url : AddUrlParam(url, "tzOffset", params.tzOffset);
  url = AddUrlParam(url, "timezoneName", timezoneName);
  url = OnSchedHelpers.IsEmpty(params.duration) ? url : AddUrlParam(url, "duration", params.duration);
  url = OnSchedHelpers.IsEmpty(params.resourceId) ? url : AddUrlParam(url, "resourceId", params.resourceId);
  url = OnSchedHelpers.IsEmpty(params.resourceIds) ? url : AddUrlParam(url, "resourceIds", params.resourceIds);
  url = OnSchedHelpers.IsEmpty(params.roundRobin) ? url : AddUrlParam(url, "roundRobin", params.roundRobin);
//        console.log("CreateAvailabilityUrl="+url)
  return url;
}

export const AddUrlParam = (url, name, value) => {
  if (value == undefined)
      return url;
  if (url.indexOf("?") !== -1)
      url += "&" + name + "=" + value;
  else
      url += "?" + name + "=" + value;
  return url;
}

export const GetFormElementDataValue = e => {
  if (e.dataset.type == "int")
      return OnSchedHelpers.ParseInt(e.value);
  else
  if (e.dataset.type == "bool")
      return e.checked;
  else
      return e.value;
}

export const DataValue = (value) => value === undefined ? "" : value;

export const CheckboxChecked = value => value ? "checked=\"checked\"" : "";

export const Tooltips = elementId => {
  const currentElement = document.getElementById(elementId);

  var cumulativeOffset = function(element) {
    var top = 0, left = 0;
    do {
      top += element.offsetTop  || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while(element);

    return {
      top: top,
      left: left
    };
  };

  var Tooltip = {
    tooltip: undefined,
    target: undefined,
    bindEvents: function() {
      var elTooltip = document.getElementById('onsched-tooltip');
      
      if (!elTooltip) {
        elTooltip = document.createElement('DIV');
        elTooltip.id = 'onsched-tooltip';
        currentElement.appendChild(elTooltip);
      }

      Tooltip.tooltip = elTooltip;

      var targets = document.querySelectorAll('[data-onsched-tooltip]' );
      
      for (var i = 0; i < targets.length; ++i) {
          targets[i].addEventListener('mouseover', Tooltip.show);
            targets[i].addEventListener('mouseleave', Tooltip.hide);
      }
      
      Tooltip.tooltip.addEventListener('mouseover', Tooltip.hide);
      
      window.addEventListener('resize', Tooltip.show);
    },
 
    show: function(e)
    {
      Tooltip.target = this;
      console.log('tooltip', Tooltip.target, Tooltip.target.dataset)
      const tip = Tooltip.target.dataset.onschedTooltip;
      const currentElement = document.getElementById(elementId)

      Tooltip.tooltip.innerHTML = tip ? tip : '';

      var pos_left = cumulativeOffset(Tooltip.target).left + ( Tooltip.target.offsetWidth / 2 ) - ( Tooltip.tooltip.offsetWidth / 2 ),
          pos_top  = cumulativeOffset(Tooltip.target).top + Tooltip.tooltip.offsetHeight - 20;

      if( pos_left < 100 ) {
        pos_left = cumulativeOffset(Tooltip.target).left + Tooltip.target.offsetWidth;
      }

      if( pos_left + Tooltip.tooltip.offsetWidth > (currentElement.offsetLeft + currentElement.clientWidth) - 100 ) {
        pos_left = cumulativeOffset(Tooltip.target).left - Tooltip.target.offsetWidth;
      }
      
      if( pos_top < 0 ) {
        var pos_top  = Tooltip.target.offsetTop + Tooltip.target.offsetHeight;
      }
      
      Tooltip.tooltip.style.left = pos_left + 'px';
      Tooltip.tooltip.style.top = pos_top + 'px';

      Tooltip.tooltip.className += ' show';
    },
    hide: function()
    {
      Tooltip.tooltip.className = Tooltip.tooltip.className.replace('show', '');
    }
  };

  Tooltip.bindEvents();
}

// export const Tooltips = element => {
//   // Select the node that will be observed for mutations
//   const targetNode = document.getElementById(element.id);

//   // Options for the observer (which mutations to observe)
//   const config = { attributes: true, childList: true, subtree: true };

//   // Callback function to execute when mutations are observed
//   const callback = function(mutationList, observer) {
//     // Use traditional 'for loops' for IE 11
//     displayTooltips(element.id)
//   };

//   // Create an observer instance linked to the callback function
//   const observer = new MutationObserver(callback);

//   // Start observing the target node for configured mutations
//   observer.observe(targetNode, config);

// }
